import { defineMessage } from 'react-intl';

export const name = defineMessage({
  defaultMessage: 'Kysymys',
});

export const elementType = 'element';
